/**
 * String Utilities
 * String normalization, escaping, comparison
 */

/**
 * Normalize string for comparison
 * @param {string} value
 * @returns {string}
 */
export function normalizeCompareStr(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Escape string for use inside Algolia filter quoted value.
 * Prevents pipe (|) from being parsed as OR and fixes "incomplete string" errors.
 * @param {string} str
 * @returns {string}
 */
export function escapeAlgoliaFilterValue(str) {
  if (typeof str !== 'string') return '';
  return str
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\|/g, '\\|')
    .replace(/'/g, "\\'")
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)');
}

/**
 * Normalize search query: replace pipe with space so "Nike | MLB" is not
 * parsed as OR / broken by separators and matches "Nike | MLB Community Camps".
 * @param {string} str
 * @returns {string}
 */
export function normalizeTitleSearchQuery(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/\|/g, ' ').replace(/\s+/g, ' ').trim();
}

console.log('📦 String utils module loaded');
